"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HellsFuryAbilityHandler = exports.HellsFuryActorAbilityFactory = exports.HellsFuryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class HellsFuryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HellsFury;
        this.__typeName = "HellsFury";
    }
}
exports.HellsFuryAbilityArgs = HellsFuryAbilityArgs;
let HellsFuryActorAbilityFactory = class HellsFuryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HellsFury", "Self", 0);
    }
};
HellsFuryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HellsFury")
], HellsFuryActorAbilityFactory);
exports.HellsFuryActorAbilityFactory = HellsFuryActorAbilityFactory;
let HellsFuryAbilityHandler = class HellsFuryAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Hell's Fury", "Applies Hellscorned to attackers", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Attacked, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttacked", {
                applyTo: "attacker",
                effects: [{
                        duration: Duration_1.Duration.Ticks(8),
                        effect: new core_1.HellScornedEffectArgs(8),
                        percentChance: 100
                    }]
            })),
            supernatural: true
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
HellsFuryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HellsFury)
], HellsFuryAbilityHandler);
exports.HellsFuryAbilityHandler = HellsFuryAbilityHandler;
